import Swiper, { Navigation, Pagination } from "swiper";
import {
  isFavorite,
  addFavoriteItem,
  removeFavoriteItem,
} from "@src/utils/favorite";
import { getPageCategory } from "@src/utils/helper";
import {
  getPropertyIdsFromSlides,
  pushSelectItemEventFromId,
  pushViewItemListEventFromSlides,
} from "./analytic";
import { isMobile } from "@src/utils/matchMedia";

import "./index.css";

export function setupNearby() {
  const container = document.querySelector(".container-nearby");

  if (container == null) {
    return;
  }

  const pageCategory = getPageCategory();

  const swiper = new Swiper(".container-nearby-swiper", {
    slidesPerView: "auto",
    spaceBetween: 24,
    modules: [Navigation, Pagination],
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  // set favorite
  const favorites = container.querySelectorAll(
    ".container-nearby-item-favorite"
  ) as NodeListOf<HTMLButtonElement>;
  favorites.forEach((favorite) => {
    const propertyId = favorite.getAttribute("data-property-id") || "";
    favorite.setAttribute("data-favorite", isFavorite(propertyId).toString());
  });

  // toggle favorite
  container.addEventListener("click", (event) => {
    if (event.target instanceof HTMLElement) {
      const btn = event.target.closest(".container-nearby-item-favorite");
      const propertyId = btn?.getAttribute("data-property-id");
      if (btn && propertyId) {
        if (btn.getAttribute("data-favorite") === "true") {
          // remove from favorite
          btn.setAttribute("data-favorite", "false");
          removeFavoriteItem(propertyId);
        } else {
          // add to favorite
          btn.setAttribute("data-favorite", "true");
          addFavoriteItem(propertyId);
        }
      }
    }
  });

  function getVisibleSlides(activeIndex: number) {
    return swiper.slides.slice(
      activeIndex,
      activeIndex +
        (typeof swiper.params.slidesPerView === "number"
          ? swiper.params.slidesPerView
          : isMobile()
          ? 1
          : 4)
    );
  }

  if (pageCategory === "parking") {
    // GTM push `view_item_list` event when first load list
    pushViewItemListEventFromSlides(
      getVisibleSlides(swiper.activeIndex),
      pageCategory
    );

    // init previous slides
    let perviousPropertyIds = getPropertyIdsFromSlides(
      getVisibleSlides(swiper.activeIndex)
    );

    // slide change
    swiper.on("slideChangeTransitionEnd", function () {
      const currentSlides = getVisibleSlides(swiper.activeIndex);
      // GTM push `view_item_list` event when slide change
      pushViewItemListEventFromSlides(
        // exclude previous slides
        currentSlides.filter(
          (slide: HTMLElement) =>
            !perviousPropertyIds.includes(getPropertyIdsFromSlides([slide])[0])
        ),
        pageCategory
      );
      // update previous slides
      perviousPropertyIds = getPropertyIdsFromSlides(currentSlides);
    });

    // GTM push `select_item` event
    container.addEventListener("click", function (e) {
      const source = e.target as HTMLElement;
      if (source && source.classList.contains("container-nearby-item-button")) {
        const propertyId = source
          .closest(".container-nearby-item")
          ?.querySelector(".container-nearby-item-favorite")
          ?.getAttribute("data-property-id");

        pushSelectItemEventFromId(propertyId || "", pageCategory || "");
      }
    });
  }
}
